export default {
    loadPerformDashModule(module, agentCode) {
        return this.getRequest(`/api/private/stats/perf_dash/${module}/${agentCode}`)
            .then(function(json) {
                return json
            }).catch(function(err) {
				const msg = err.status === 404
					? 'Page not found.'
					: err.message
                return {
                    error: true,
                    text: msg,
                    visible: true,
                }
            })
    },

    updateIncomeGoal(value, agentCode) {
        const params = {
            ConfigName: 'MonthlyIncomeGoal',
            ConfigValue: value,
            DataType: 'number',
        }
        return this.postRequest(`api/private/stats/perf_dash/desire_income_goal/${agentCode}`, params).then(
            function(json) {
				return json
            },
            function(error) {
				return {
					error: true,
					cause: error,
				}
            })
    },
}
